import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowUpOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowUpOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m21 10.19-9-6.3-9 6.3v2.44l8-5.6v13.08h2V7.03l8 5.6v-2.44Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowUpOutlined;